import React from 'react';
import { CoreLink } from '@uncinc/react-drupal-core';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';
import classnames from 'classnames';
import WysiwygField from '../../../WysiwygField';
import './style.scss';

const CollapsableStepPlanIcon = (props) => {
  const {
    title,
    body,
    url = '',
    className,
    roundedIcon,
    svg,
    supertitle,
    middle,
  } = props;

  return (
    <div
      className={classnames(className, 'CollapsableStepPlanIcon', { CollapsableStepPlanIcon__open: true, CollapsableStepPlanIcon__showIcon: true })}
    >
      <CoreLink to={url}>
        <div className="CollapsableStepPlanIcon__inner">
          <div className={classnames('CollapsableStepPlanIcon__icon',
            {
              'CollapsableStepPlanIcon__icon--middle': middle,
            })}>
            <Image src={svg} alt={title} />
          </div>
          <div className="CollapsableStepPlanIcon__container">
            {supertitle && (
              <div className="CollapsableStepPlanIcon__supertitle">
                {supertitle}
              </div>
            )}
            <strong className={`CollapsableStepPlanIcon__title   ${url && url.length > 0 && 'icon-chevron-right icon-after'}`}>{title}</strong>
            <div className={classnames('CollapsableStepPlanIcon__body', { CollapsableStepPlanIcon__body__rounded: roundedIcon })}>
              {body && (
                <WysiwygField
                  property="schema:text"
                  html={body}
                  className="subheading2"
                />
              )}
            </div>
          </div>
        </div>
      </CoreLink>
    </div>
  );
};

export default CollapsableStepPlanIcon;
